// Shared by the oversight-console resolution card (client) and the
// product_match resolution service (server): the stale-card echo's
// resolvedLines fingerprint. The card computes it from the payload it
// DISPLAYED; the server recomputes it from the CLAIMED row's payload; any
// drift (e.g. a buyer revision touching only resolved-line quantities) trips
// the guard. One implementation, imported by both sides — a client/server
// drift here would 409 every save. JSON-serialized so adjacent qty+name
// pairs can never collide with a name that happens to contain digits, spaces,
// or delimiter characters.
export function fingerprintResolvedLines(resolvedLines: Array<{ name: string; qty: number }>): string {
  return JSON.stringify(resolvedLines.map((r) => [r.qty, r.name]));
}
